module.exports = __webpack_public_path__ + "static/media/like_active.7a0bc107.svg";